/**
 * Row background tints for the timeline (issue #33). Toggl separates each
 * member's area with a full-row background tint instead of a hairline
 * border, making it obvious which tasks belong to which user. Entries
 * without members land in a dedicated "Unassigned" row with a neutral
 * tint — a task is not always attached to a member at creation time, we
 * attach it later.
 */
export const MEMBER_ROW_TINT = 'bg-member';
export const UNASSIGNED_ROW_TINT = 'bg-muted/60';
export const UNASSIGNED_ROW_ID = '__unassigned__';
export const UNASSIGNED_ROW_LABEL = 'Unassigned';
